export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'header',
        type: 'string',
        useInFilter: true,
    },
    {
        name: 'txt',
        type: 'string',
        useInFilter: true,
    },
    {
        name: 'pos',
        sortField: 'pos',
        type: 'number',
        useInFilter: true,
    },
    {
        name: 'sr',
        sortField: 'sr',
        type: 'sr',
        callback: 'sr',
        useInFilter: true,
    },
    {
        name: 'ws',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'wsk',
        sortField: 'wsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'superwsk',
        sortField: 'superwsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'adscnt',
        sortField: 'adscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'docs',
        sortField: 'docs',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'avbid',
        sortField: 'avbid',
        type: 'number',
        callback: 'currency',
        dataClass: 'ral avbid',
        useInFilter: true,
    },
    {
        name: 'isgeo',
        type: 'bool',
        useInFilter: true,
        visible: false,
    },
    {
        name: 'isquest',
        type: 'bool',
        useInFilter: true,
        visible: false,
    },
    {
        name: 'serp',
        sortField: 'serp',
        type: 'dateRange',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: '__slot:keys_meta',
        dataClass: 'text-center',
        useInFilter: false,
    },
]
